<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}數字題
    </template>
    <v-card-text class="text-start" slot="content">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx" class="blod quest_topic">{{ name }}</div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>

      <v-text-field
        maxlength="20"
        v-model="ques.value"
        outlined
        class="centered-input mt-4 peter-text"
        type="number"
        :max="ques.maxiNum"
        :min="ques.miniNum"
        append-outer-icon="add"
        @click:append-outer="increment"
        prepend-icon="remove"
        @change="onChange"
        @click:prepend="decrement"
      ></v-text-field>
      <v-input
        :value="ques.value"
        :rules="[
          v => {
            let pass = !(ques.isRequired && !ques.value)
            return pass ? true : '此題為必填'
          }
        ]"
      >
      </v-input>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  },
  methods: {
    // 不要讓填入的數字超過 max, min
    onChange() {
      let currentValue = parseInt(this.ques.value)
      if (currentValue > this.ques.maxiNum) {
        this.ques.value = this.ques.maxiNum
      } else if (currentValue < this.ques.miniNum) {
        this.ques.value = this.ques.miniNum
      }
    },
    increment() {
      if (this.ques.value === null) this.ques.value = this.ques.maxiNum
      let inc = parseInt(this.ques.value) + 1
      if (inc <= this.ques.maxiNum) {
        this.ques.value = inc
      }
    },
    decrement() {
      if (this.ques.value === null) this.ques.value = this.ques.miniNum
      let dec = parseInt(this.ques.value) - 1
      if (dec >= this.ques.miniNum) {
        this.ques.value = dec
      }
    }
  }
}
</script>

<style lang="scss">
.centered-input input {
  text-align: center !important;
}
</style>
